module.exports = __webpack_public_path__ + "media/images/countrysquared/pl-072dfb0d6081cdf5d6b3368af04972b0.svg";